/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import axios from 'axios';
import ApolloClient from 'apollo-boost';
import { getBaseUrl } from 'shared/apollo/client';
import cubejs from '@cubejs-client/core';
import { getImpactColumns } from './queries/impact';
import { mixedQuery, parseQuery } from './queries';
import { API_URL, API_CUBE } from 'shared/utils/constants';

export * from './constants';
export const api = `${getBaseUrl()}/`;

export const getAuthorizationHeader = () => {
  return Object.keys(sessionStorage).reduce((acc, key) => {
    if (
      key.startsWith('CognitoIdentityServiceProvider') &&
      key.endsWith('idToken')
    ) {
      return sessionStorage.getItem(key);
    }
    return acc;
  }, '');
};

export const AuthReady = () => {
  return !!getAuthorizationHeader();
};

const DEFAULT_LOCAL_TOKEN = getAuthorizationHeader();
export const apiCube = API_CUBE;

export const getGhostedHeader = () => {
  return sessionStorage.getItem('trueimpact.ghostedUsername');
};

export const setAuthorizationHeader = token => {
  axios.defaults.headers.common['ti-id-token'] = token;
  if (window.location.hostname === 'localhost' && !token) {
    axios.defaults.headers.common['ti-id-token'] = DEFAULT_LOCAL_TOKEN;
  }
  const tiGhostedUser = getGhostedHeader();
  if (tiGhostedUser) {
    axios.defaults.headers.common['ti-ghosted-user'] = tiGhostedUser;
  }
};

export const updateAuthorizationHeader = () => {
  const token = getAuthorizationHeader();
  setAuthorizationHeader(token);
};

if (window.location.hostname === 'localhost') {
  setAuthorizationHeader();
}

export const setBackendUrl = (url = API_URL) => {
  axios.defaults.baseURL = url;
};

const getCubeCookie = () => {
  const name = 'cubejs_jwt=';
  const ca = decodeURIComponent(document.cookie).split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const client = new ApolloClient({
  uri: `${API_URL}/v4`
});

export const AuthorizationCube = getCubeCookie();
export const cubejsApi = cubejs(AuthorizationCube, {
  apiUrl: `${apiCube}cubejs-api/v1`
});
export const getCubeJsApi = () => {
  const token = getCubeCookie();
  return cubejs(token, {
    apiUrl: `${apiCube}cubejs-api/v1`
  });
};

export const constructQuery = filters => {
  if (filters) {
    return mixedQuery(filters);
  }
  return '';
};

// eslint-disable-next-line no-shadow
export const parseGraqhqlResponse = (query, tabs) => {
  return parseQuery(query, tabs);
};

// eslint-disable-next-line no-shadow
export const getTableStructure = tabs => {
  const table = [];
  tabs.forEach(tab => {
    if (tab.id === 3) {
      const checked =
        tab.sections.filter(
          section => section.filters.filter(filter => filter.checked).length > 0
        ).length > 0;
      if (checked) {
        table.push({ title: 'Group Name', field: 'Group Name' });
        table.push({ title: 'Group %', field: 'Group %' });
      }
    }
    if (tab.id === 4) {
      getImpactColumns(tab).forEach(row => {
        table.push(row);
      });
    }
    if (tab.id !== 4) {
      const filters = tab.id === 3 ? tab.sections[0].filters : tab.filters;
      filters.forEach(filter => {
        if (filter.checked)
          table.push({ title: filter.filterName, field: filter.filterName });
      });
    }
  });
  return table;
};

// eslint-disable-next-line no-shadow
export const getTabId = tabs => {
  let tabId = null;
  tabs.forEach(tab => {
    if (tab.sections) {
      tab.sections.forEach(section => {
        if (section.stages) {
          section.stages.forEach(stage => {
            if (stage.filters.filter(filter => filter.checked).length > 0)
              tabId = tab.id;
          });
        } else if (section.filters.filter(filter => filter.checked).length > 0)
          tabId = tab.id;
      });
    } else if (tab.filters.filter(filter => filter.checked).length > 0)
      tabId = tab.id;
  });
  return tabId;
};

export const truncate = (value, max = 55) => {
  // eslint-disable-next-line no-restricted-globals
  if (value !== undefined && value !== null && value !== '' && !isNaN(value)) {
    return parseFloat(value).toFixed(2);
  }
  if (value && value.length > max) {
    return `${value.substring(0, max)}...`;
  }
  return value;
};

export const dumpFilters = filters => {
  // dumps selected filters to be stored the most efficent way on the API.
  return filters.reduce((values, tab) => {
    switch (tab.id) {
      case 3:
        values[3] = tab.sections.map(section => {
          return section.filters.reduce((list, filter) => {
            if (filter.checked) list.push(filter.id);
            return list;
          }, []);
        }, []);
        break;
      case 4:
        values[4] = tab.sections.map(section => {
          if (section.filters) {
            return section.filters.reduce((list, filter) => {
              if (filter.checked) list.push(filter.id);
              return list;
            }, []);
          }

          return section.stages.map(stage => {
            return stage.filters.reduce((list, filter) => {
              if (filter.checked) list.push(filter.id);
              return list;
            }, []);
          });
        });
        break;
      default:
        values[tab.id] = tab.filters.reduce((list, filter) => {
          if (filter.checked) list.push(filter.id);
          return list;
        }, []);
    }
    return values;
  }, {});
};

export const parseFilters = (tabsList, filters) => {
  // parse selected filter to the format expected on the APP.
  return tabsList.map(tab => {
    switch (tab.id) {
      case 3:
        if (tab.sections !== !undefined && tab.sections.filters !== undefined) {
          tab.sections.forEach((section, index) => {
            section.filters.forEach(filter => {
              if (filters[tab.id][index].includes(filter.id)) {
                filter.checked = true;
              } else {
                filter.checked = false;
              }
            });
          });
        }
        break;
      case 4:
        if (tab.sections !== undefined) {
          tab.sections.forEach((section, index) => {
            if (section.filters && section.filters !== undefined) {
              section.filters.forEach(filter => {
                if (filters[tab.id][index].includes(filter.id)) {
                  filter.checked = true;
                } else {
                  filter.checked = false;
                }
              });
            } else {
              section.stages.forEach((stage, stageIndex) => {
                stage.filters.forEach(filter => {
                  if ((filters[tab.id][index][stageIndex] || []).includes(filter.id)) {
                    filter.checked = true;
                  } else {
                    filter.checked = false;
                  }
                });
              });
            }
          });
        }
        break;
      default:
        if (tab.filters !== undefined) {
          tab.filters.forEach(filter => {
            if (filters[tab.id].includes(filter.id)) {
              filter.checked = true;
            } else {
              filter.checked = false;
            }
          });
        }
    }
    return tab;
  });
};


export function deepEqual(object1, object2) {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      areObjects && !deepEqual(val1, val2) ||
      !areObjects && val1 !== val2
    ) {
      return false;
    }
  }

  return true;
}

function isObject(object) {
  return object != null && typeof object === 'object';
}

export function sortObject(o) {
  var sorted = {},
  key, a = [];

  for (key in o) {
      // eslint-disable-next-line no-prototype-builtins
      if (o.hasOwnProperty(key)) {
          a.push(key);
      }
  }

  a.sort();

  for (key = 0; key < a.length; key++) {
      sorted[a[key]] = o[a[key]];
  }
  return sorted;
}